var _circle, _circle2, _text, _circle3, _circle4, _text2, _circle5, _circle6, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletBalanceCoins(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    r: 25,
    fill: "#CC9900",
    stroke: "#AA7700",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    r: 20,
    fill: "#FFD700"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 56,
    fontFamily: "Georgia",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#AA7700"
  }, "$")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 45,
    r: 25,
    fill: "#CC9900",
    stroke: "#AA7700",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 45,
    r: 20,
    fill: "#FFD700"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 51,
    fontFamily: "Georgia",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#AA7700"
  }, "$")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 50,
    r: 25,
    fill: "#CC9900",
    stroke: "#AA7700",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 50,
    r: 20,
    fill: "#FFD700"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 56,
    fontFamily: "Georgia",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#AA7700"
  }, "$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBalanceCoins);
export default __webpack_public_path__ + "static/media/wallet-balance-coins.14ec388d210176aee161f23f5985d409.svg";
export { ForwardRef as ReactComponent };